import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import addLogDocument from "./addLogDocument.js";
import { auth } from "../config/FirebaseConfig.js";
import { getUserById } from "../models/UserFunctions.js";

const addCarnetFacade = async (carnetId, file, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}carnets/${carnetId}/facade`;

  const formData = new FormData();
  formData.append("file", file);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const start = new Date();
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: formData,
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error("User not logged in");
    }

    const userData = await getUserById(currentUser.uid);
    const responseText = await response.text();
    const end = new Date();
    const elapsed = end - start;

    if (userData) {
      const orgId = userData.org_id;
      await addLogDocument(
        url,
        prefix,
        currentUser.uid,
        orgId,
        response.status.toString(),
        "",
        carnetId,
        "",
        responseText,
        "POST",
        elapsed
      );
    }

    if (response.ok) {
      return JSON.parse(responseText);
    } else {
      console.error(`Failed to add facade photo: ${response.status}`);
      throw new Error(`Failed to add facade photo: ${response.status}`);
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    throw error;
  }
};

export default addCarnetFacade;